import { PER_PAGE } from 'hb-react/shared/components/ReactSelect/constants';
import { type QueryFn } from 'hb-react/shared/components/ReactSelect/ReactSelectAdaptive/types';
import { type StorageAttachmentRecord } from 'hb-react/shared/hooks/useGlobalStorageV2/types';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

// All attributes from app/serializers/topic_serializer.rb
export interface SerializedTopic {
  accessibleByCurrentAdmin?: boolean;
  closed?: boolean;
  coverPictureSmall?: StorageAttachmentRecord;
  coverPictureSmallUrl?: string;
  id: number | string;
  name: string;
}

export type GetTopicItem = Pick<
  SerializedTopic,
  'accessibleByCurrentAdmin' | 'id' | 'name'
>;

export interface GetTopicsResponse {
  data: Array<GetTopicItem>;
  endCursor: string;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetTopicsProps {
  params: {
    fulltext?: string;
    ids?: Array<number>;
    limit: number;
    page?: number;
  };
  signal?: AbortSignal;
}

export const getTopics = ({ params, signal }: GetTopicsProps) => {
  const path = Routes.private_backoffice_topics_path();

  return axios.get<GetTopicsResponse>(path, { params, signal });
};

export const getTopicsOptions: QueryFn<GetTopicsResponse> = (
  { searchText, ids },
  signal,
) => {
  const params = {
    ...(searchText ? { fulltext: searchText } : {}),
    ...(ids
      ? {
          ids: ids,
          limit: ids.length,
        }
      : {
          limit: PER_PAGE,
          page: 1,
        }),
  };

  return getTopics({ params, signal }).then(({ data }) => data);
};
